module.exports = __webpack_public_path__ + "img/no-img.deb53e17.png";